module.exports = "pegasus/assets/theme2/twitter-icon-1.png";